// import { BookOpen, ChevronDown, ChevronUp, PlayCircle } from "lucide-react";
// import React, { useEffect, useRef, useState } from "react";
// import { useParams } from "react-router-dom";
// import { getCourseDetails } from "../API/API";
// import { defaultCourseData } from "../pages/defaultCourseData.js";

// const CourseDetails = () => {
//   const [courseData, setCourseData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [progress, setProgress] = useState(0);
//   const [expandedModules, setExpandedModules] = useState({});
//   const videoRef = useRef(null);
//   const { courseName } = useParams();

//   useEffect(() => {
//     const normalize = (str) =>
//       str.toLowerCase().replace(/[^a-z0-9]/gi, "");

//     const fetchDetails = async () => {
//       try {
//         const data = await getCourseDetails();
//         if (data && Object.keys(data).length > 0) {
//           const filtered = Object.fromEntries(
//             Object.entries(data).filter(
//               ([_, val]) => normalize(val.name) === normalize(courseName)
//             )
//           );
//           setCourseData(filtered);
//         } else {
//           const fallback = Object.fromEntries(
//             Object.entries(defaultCourseData).filter(
//               ([_, val]) => normalize(val.name) === normalize(courseName)
//             )
//           );
//           setCourseData(fallback);
//         }
//       } catch (error) {
//         console.error("Error fetching course details:", error);
//         const fallback = Object.fromEntries(
//           Object.entries(defaultCourseData).filter(
//             ([_, val]) => normalize(val.name) === normalize(courseName)
//           )
//         );
//         setCourseData(fallback);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDetails();
//   }, [courseName]);

//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video) return;

//     const updateProgress = () => {
//       const current = video.currentTime;
//       const duration = video.duration;
//       if (duration > 0) {
//         setProgress((current / duration) * 100);
//       }
//     };

//     video.addEventListener("timeupdate", updateProgress);

//     return () => {
//       video.removeEventListener("timeupdate", updateProgress);
//     };
//   }, [selectedVideo]);

//   const openVideo = (videoUrl) => {
//     setSelectedVideo(videoUrl);
//     setProgress(0);
//   };

//   const closeModal = () => {
//     setSelectedVideo(null);
//     setProgress(0);
//   };

//   const toggleModule = (index) => {
//     setExpandedModules((prev) => ({
//       ...prev,
//       [index]: !prev[index],
//     }));
//   };

//   if (loading)
//     return (
//       <p className="text-center text-xl mt-20 text-blue-600">
//         Loading course details...
//       </p>
//     );

//   if (!courseData || Object.keys(courseData).length === 0)
//     return <p className="text-center text-red-600">No course data found.</p>;

//   return (
//     <div className="max-w-5xl mx-auto px-6 py-12">
//       {Object.entries(courseData).map(([courseKey, course]) => (
//         <div key={courseKey} className="mb-12">
//           <div className="text-center mb-10">
//             <h1 className="text-4xl font-extrabold text-indigo-700">
//               {course.name}
//             </h1>
//             <p className="text-gray-600 mt-3 text-lg">
//               Explore modules, topics, and learn interactively
//             </p>
//           </div>

//           {course.modules.map((module, idx) => (
//             <div
//               key={idx}
//               className="mb-6 border rounded-xl shadow-lg p-6 bg-white"
//             >
//               <button
//                 className="flex items-center justify-between w-full text-left text-xl font-semibold text-blue-800"
//                 onClick={() => toggleModule(idx)}
//               >
//                 <span className="flex items-center">
//                   <BookOpen className="w-6 h-6 mr-3" />
//                   {module.moduleTitle}
//                 </span>
//                 {expandedModules[idx] ? <ChevronUp /> : <ChevronDown />}
//               </button>

//               {expandedModules[idx] && (
//                 <ul className="list-disc ml-8 mt-4 space-y-2 text-blue-600">
//                   {module.topics.map((topic, tIdx) => (
//                     <li
//                       key={tIdx}
//                       className="hover:underline cursor-pointer transition duration-200 ease-in-out"
//                       onClick={() => openVideo(topic.videoLink)}
//                     >
//                       {topic.title}
//                       {topic.subtopics && (
//                         <ul className="ml-6 mt-2 space-y-2">
//                           {topic.subtopics.map((sub, sIdx) => (
//                             <li
//                               key={sIdx}
//                               className="flex items-center gap-3 cursor-pointer group"
//                               onClick={() => openVideo(sub.videoLink)}
//                             >
//                               <PlayCircle className="w-5 h-5 text-indigo-500 group-hover:scale-110 transition-transform" />
//                               <span className="text-sm text-gray-800 group-hover:text-indigo-600 transition-colors">
//                                 {sub.title}
//                               </span>
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </div>
//           ))}
//         </div>
//       ))}

//       {/* Video Modal */}
//       {selectedVideo && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
//           <div className="bg-white rounded-lg shadow-2xl w-[90%] max-w-3xl relative">
//             <button
//               className="absolute top-2 right-3 text-red-600 text-2xl font-bold"
//               onClick={closeModal}
//             >
//               ×
//             </button>
//             <div className="p-4">
//               <video
//                 ref={videoRef}
//                 src={selectedVideo}
//                 controls
//                 autoPlay
//                 className="w-full rounded-md"
//               />
//               <div className="mt-3 h-3 bg-gray-200 rounded overflow-hidden">
//                 <div
//                   className="h-full bg-blue-500"
//                   style={{ width: `${progress}%` }}
//                 ></div>
//               </div>
//               <p className="text-right text-sm mt-1 text-gray-500">
//                 {Math.round(progress)}% watched
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };


import { BookOpen, ChevronDown, ChevronUp, PlayCircle } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCourseDetails } from "../API/API";
import { defaultCourseData } from "../pages/defaultCourseData.js";

const CourseDetails = () => {
  const [courseData, setCourseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [progress, setProgress] = useState(0);
  const [expandedModules, setExpandedModules] = useState({});
  const videoRef = useRef(null);
  const { courseName } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const program = queryParams.get("program");

  useEffect(() => {
    const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/gi, "");

    const fetchDetails = async () => {
      try {
        const data = await getCourseDetails();
        if (data && Object.keys(data).length > 0) {
          const filtered = Object.fromEntries(
            Object.entries(data).filter(
              ([_, val]) => normalize(val.name) === normalize(courseName)
            )
          );
          setCourseData(filtered);
        } else {
          const fallback = Object.fromEntries(
            Object.entries(defaultCourseData).filter(
              ([_, val]) => normalize(val.name) === normalize(courseName)
            )
          );
          setCourseData(fallback);
        }
      } catch (error) {
        console.error("Error fetching course details:", error);
        const fallback = Object.fromEntries(
          Object.entries(defaultCourseData).filter(
            ([_, val]) => normalize(val.name) === normalize(courseName)
          )
        );
        setCourseData(fallback);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [courseName]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateProgress = () => {
      const current = video.currentTime;
      const duration = video.duration;
      if (duration > 0) {
        setProgress((current / duration) * 100);
      }
    };

    video.addEventListener("timeupdate", updateProgress);

    return () => {
      video.removeEventListener("timeupdate", updateProgress);
    };
  }, [selectedVideo]);

  const closeModal = () => {
    setSelectedVideo(null);
    setProgress(0);
  };

  const toggleModule = (index) => {
    setExpandedModules((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  <div className="back-button"></div>

  const goBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(program ? `/courses?program=${program}` : "/courses");
    }
  };

  if (loading)
    return (
      <p className="text-center text-xl mt-20 text-blue-600">
        Loading course details...
      </p>
    );

  if (!courseData || Object.keys(courseData).length === 0)
    return <p className="text-center text-red-600">No course data found.</p>;

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      {Object.entries(courseData).map(([courseKey, course]) => (
        <div key={courseKey} className="mb-12">
          <button 
            onClick={goBack}
            className="min-w-1 mb-8 ml-[-10px] px-5 py-2 bg-gradient-to-r from-[#6a11cb] to-[#2575fc] text-white font-semibold rounded-full shadow-lg transition-all hover:from-[#5a01bb] hover:to-[#1565f9]"
            id="back-button"
          >
            ← Back
          </button>

          <div className="text-center mb-10">
            <h1 className="text-4xl font-extrabold text-indigo-700">
              {course.name}
            </h1>
            <p className="text-gray-600 mt-3 text-lg">
              Explore modules, topics, and learn interactively
            </p>
          </div>

          {course.modules.map((module, idx) => (
            <div
              key={idx}
              className="mb-6 border rounded-xl shadow-lg p-6 bg-white"
            >
              <button
                className="flex items-center justify-between w-full text-left text-xl font-semibold text-blue-800"
                onClick={() => toggleModule(idx)}
              >
                <span className="flex items-center">
                  <BookOpen className="w-6 h-6 mr-3" />
                  {module.moduleTitle}
                </span>
                {expandedModules[idx] ? <ChevronUp /> : <ChevronDown />}
              </button>

              {expandedModules[idx] && (
                <ul className="list-disc ml-8 mt-4 space-y-2 text-blue-600">
                  {module.topics.map((topic, tIdx) => (
                    <li
                      key={tIdx}
                      className="transition duration-200 ease-in-out text-gray-700"
                    >
                      {topic.title}
                      {topic.subtopics && (
                        <ul className="ml-6 mt-2 space-y-2">
                          {topic.subtopics.map((sub, sIdx) => (
                            <li
                              key={sIdx}
                              className="flex items-center gap-3 text-gray-700"
                            >
                              <PlayCircle className="w-5 h-5 text-indigo-300" />
                              <span className="text-sm">{sub.title}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      ))}

      {selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-2xl w-[90%] max-w-3xl relative">
            <button
              className="absolute top-2 right-3 text-red-600 text-2xl font-bold"
              onClick={closeModal}
            >
              ×
            </button>
            <div className="p-4">
              <video
                ref={videoRef}
                src={selectedVideo}
                controls
                autoPlay
                className="w-full rounded-md"
              />
              <div className="mt-3 h-3 bg-gray-200 rounded overflow-hidden">
                <div
                  className="h-full bg-blue-500"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-right text-sm mt-1 text-gray-500">
                {Math.round(progress)}% watched
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseDetails;
